import { gsap } from "gsap";

export default class Footer {

    constructor(e) {

        this.elm = e.detail.element.querySelector('[data-footer]');
        this.content = this.elm.querySelector('[data-footer-content]');

        this.init();
    }

    init() {

        let mm = gsap.matchMedia();
        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)",
            hasHover: "(hover: hover) and (pointer: fine)"
        }, (context) => {

            let { isDesktop, isMobile, reduceMotion, hasHover } = context.conditions;

            if(hasHover) { // No Touch

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: this.elm,
                        start: "top bottom",
                        end: 'bottom bottom',
                        scrub: 1
                    },
                });

                tl.to(this.content, {
                    translateY: 0,
                    opacity: 1,
                    ease: 'none',
                    duration: 1,
                });

            } else { // Touch

                gsap.set(this.content, {
                    translateY: 0,
                    opacity: 1,
                });

            }

        });

    }
}